// extracted by mini-css-extract-plugin
export var emphasis = "emphasis-module--emphasis--+34dC";